import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import './API.css';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const CatalogoApiDetailEdit =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				informacoesTecnicasAPI: {
					id: '',	
					nome: '',	
					orgao: '',	
					fornecedoraHomologacao: '',
					fornecedoraHomologacaoDisponivel: true,
					exemploRequisicao: '',
					exemploRequisicaoToken: '',
					endpointProducao: '',
					endpointTokenProducao: '',
					endpointHomologacao: '',
					endpointTokenHomologacao: '',
				},
				fornecedorasHomologacao: [],
				botoesHabilitados: true,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.salvar = this.salvar.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Informações Técnicas da Plataforma de Interoperabilidade</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			const user = this.props.user;
			const edicao = this.props.edicao;

			if(id){
				api.get(`/api/aplicacao-fornecedora/informacoes-tecnicas/${id}`)
				.then(response => { 
					const informacoesTecnicasAPI = response.data;
					this.setState(
						{
							informacoesTecnicasAPI,
						}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as informações técnicas da API " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			}

			if(user.isMantenedor === true && edicao === true) {
				api.get('/api/aplicacao-fornecedora/ambiente/H')
				.then(response => { 
					this.setState(
						{
							fornecedorasHomologacao: response.data,
						}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as fornecedoras de homologação " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			}
		}

		renderForm() {
			const user = this.props.user;
			const edicao = this.props.edicao;
			const edicaoHabilitada = user && user.isMantenedor === true && edicao === true;
			const { informacoesTecnicasAPI, fornecedorasHomologacao } = this.state;
			const { id, nome, orgao, orgaoOperador,fornecedoraHomologacao, nomeFornecedoraHomologacao, fornecedoraHomologacaoDisponivel, endpointTokenHomologacao, endpointHomologacao, endpointTokenProducao, endpointProducao,exemploRequisicaoToken, exemploRequisicao } = informacoesTecnicasAPI;
			return(
				<div className="container-fluid">
					<div className="br-form">

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{nome}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Órgão Fornecedor:</label>
										{orgao}
									</div>
								</div>
							</div>
							
							{this.state.informacoesTecnicasAPI.orgaoOperador &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Órgão Operador de Dados:</label>
											{orgaoOperador}
										</div>
									</div>
								</div>
							}
						</div>

						{user.isMantenedor === true &&
							<div className="row">
								<div className="col-sm">
									<div className="field">
										<div className="input">
											<label htmlFor="fornecedoraHomologacao">API de Homologação (ambiente de produção):</label>
											{edicaoHabilitada === true &&
												<SelectSearch
													id="fornecedoraHomologacao"
													name="fornecedoraHomologacao"
													options={fornecedorasHomologacao.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
													includeAllOption={true}
													allOptionName="Selecione"
													onChange={this.handleInputChange}
													value={fornecedoraHomologacao}
													disabled={!edicao}
												/>
											}
											{edicaoHabilitada === false && nomeFornecedoraHomologacao &&
												<>
													{nomeFornecedoraHomologacao}
												</>
											}
										</div>
									</div>
								</div>

								{ !fornecedoraHomologacao &&
									<div className="col-sm">
										<div className="field">
											<div className="input">
												<label htmlFor="fornecedoraHomologacaoDisponivel">API de homologação disponível no ambiente de homologação do Conectagov:</label>
												{edicaoHabilitada === true &&
													<SelectSearch
														id="fornecedoraHomologacaoDisponivel"
														name="fornecedoraHomologacaoDisponivel"
														options={[{value: true, label: 'Sim'}, {value: false, label: 'Não'}]}
														onChange={this.handleInputChange}
														value={fornecedoraHomologacaoDisponivel}
														disabled={!edicao}
													/>
												}
												{edicaoHabilitada === false &&
													<>
														{fornecedoraHomologacaoDisponivel === true ? 'Sim' : 'Não'}	
													</>
												}
											</div>
										</div>
									</div>	
								}
							</div>
						}

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="endpointTokenHomologacao">Token - Endpoint de homologação:</label>
										<input type="text" name="endpointTokenHomologacao" 
											value={endpointTokenHomologacao} 
											disabled={true} 
											/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="endpointHomologacao">Endpoint de homologação:</label>
										<input type="text" name="endpointHomologacao" 
											value={endpointHomologacao} 
											disabled={true} 
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="endpointTokenProducao">Token - Endpoint de produção:</label>
										<input type="text" name="endpointTokenProducao" 
											value={endpointTokenProducao} 
											disabled={true} 
											/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="endpointProducao">Endpoint de produção:</label>
										<input type="text" name="endpointProducao" 
											value={endpointProducao} 
											disabled={true} />
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="exemploRequisicaoToken">Exemplo de Requisição do Token:</label>
										<textarea name="exemploRequisicaoToken" 
											value={exemploRequisicaoToken} 
											disabled={true} 
											className="texto-alinhado-esquerda"
											maxLength={500} style={{height:"250px"}}/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="exemploRequisicao">Exemplo de Requisição da API:</label>
										<textarea name="exemploRequisicao" 
											value={exemploRequisicao} 
											onChange={this.handleInputChange} 
											disabled={!edicaoHabilitada} 
											maxLength={2000} style={{height:"250px"}}/>
									</div>
								</div>
							</div>
						</div>

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{edicaoHabilitada === true &&
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>Salvar</button>
								}
								{ user.isMantenedor === true && edicao === false &&
									<Link to={`/api/catalogo/edit/${id}`}>
										<button type="button" className="button is-primary">Alterar</button>
									</Link>
								}
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const informacoesTecnicasAPI = this.state.informacoesTecnicasAPI;
			informacoesTecnicasAPI[nome] = valor;
			this.setState({ informacoesTecnicasAPI });
		}

		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState({botoesHabilitados:false});
			const informacoesTecnicasAPI = this.state.informacoesTecnicasAPI;
			const url = '/api/aplicacao-fornecedora/informacoes-tecnicas';
			const options = {
				method: 'put',
				url,
				"data" : informacoesTecnicasAPI
			}

			this.props.mostraAguardando();

			api(options)
				.then(response => {
					const mensagem = 'Informações técnicas da API alteradas com sucesso!';
					this.setState({ 
						informacoesTecnicasAPI: response.data ,
					});
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = 'Não foi possível alterar as informações técnicas da API.';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);

				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});   

		}

		validaFormulario(){
			let mensagens = [];

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens);
				throw new Error("Formulário não preenchido corretamente.");
			}
		}
	}

) // redux
); // router